<template>
    <section class="section language pb-0">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-xl-8">
                    <div class="section__header">
                        <h2 class="h2">AI Voices every language in the world</h2>
                        <p>
                            Generate realistic Text to Speech (TTS) audio using our online
                            AI Voice Generator and the best synthetic voices. Instantly
                            convert text in to natural-sounding speech and download as MP3
                            and WAV audio files.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="language__slider">
            <div class="swiper-wrapper">
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/canada.png')" alt="Image">
                    </div>
                    <p class="fw-5">canada english</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/usa.png')" alt="Image">
                    </div>
                    <p class="fw-5">USA English</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/uk.png')" alt="Image">
                    </div>
                    <p class="fw-5">british english</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/irish.png')" alt="Image">
                    </div>
                    <p class="fw-5">irish english</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/turkish.png')" alt="Image">
                    </div>
                    <p class="fw-5">turkish</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/italy.png')" alt="Image">
                    </div>
                    <p class="fw-5">italian</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/french.png')" alt="Image">
                    </div>
                    <p class="fw-5">french</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/japan.png')" alt="Image">
                    </div>
                    <p class="fw-5">japanese</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/china.png')" alt="Image">
                    </div>
                    <p class="fw-5">chinese</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/india.png')" alt="Image">
                    </div>
                    <p class="fw-5">hindi</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/bangladesh.png')" alt="Image">
                    </div>
                    <p class="fw-5">bengali</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/malay.png')" alt="Image">
                    </div>
                    <p class="fw-5">malay</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/filipine.png')" alt="Image">
                    </div>
                    <p class="fw-5">filipino</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/portugal.png')" alt="Image">
                    </div>
                    <p class="fw-5">Portuguese</p>
                </div>
                <div class="language__slider-single swiper-slide">
                    <div class="thumb">
                        <img :src="require('@/assets/images/flag/australia.png')" alt="Image">
                    </div>
                    <p class="fw-5">Australia</p>
                </div>
            </div>
        </div>
        <div dir="rtl">
            <div class="language__slider-rtl">
                <div class="swiper-wrapper">
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/canada.png')" alt="Image">
                        </div>
                        <p class="fw-5">canada english</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/usa.png')" alt="Image">
                        </div>
                        <p class="fw-5">USA English</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/uk.png')" alt="Image">
                        </div>
                        <p class="fw-5">british english</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/irish.png')" alt="Image">
                        </div>
                        <p class="fw-5">irish english</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/turkish.png')" alt="Image">
                        </div>
                        <p class="fw-5">turkish</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/italy.png')" alt="Image">
                        </div>
                        <p class="fw-5">italian</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/french.png')" alt="Image">
                        </div>
                        <p class="fw-5">french</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/japan.png')" alt="Image">
                        </div>
                        <p class="fw-5">japanese</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/china.png')" alt="Image">
                        </div>
                        <p class="fw-5">chinese</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/india.png')" alt="Image">
                        </div>
                        <p class="fw-5">hindi</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/bangladesh.png')" alt="Image">
                        </div>
                        <p class="fw-5">bengali</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/malay.png')" alt="Image">
                        </div>
                        <p class="fw-5">malay</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/filipine.png')" alt="Image">
                        </div>
                        <p class="fw-5">filipino</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/portugal.png')" alt="Image">
                        </div>
                        <p class="fw-5">Portuguese</p>
                    </div>
                    <div class="language__slider-single swiper-slide">
                        <div class="thumb">
                            <img :src="require('@/assets/images/flag/australia.png')" alt="Image">
                        </div>
                        <p class="fw-5">Australia</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script scoped>
    import Swiper from 'swiper';
    import 'swiper/swiper-bundle.css';

    export default {
        name: "Language",
        mounted() {
            new Swiper('.language__slider', {
                slidesPerView: 'auto',
                slidesPerGroup: 12,
                loop: true,
                speed: 80000,
                easing: 'linear',
                autoplay: {
                    delay: 0,
                },
                spaceBetween: 30,
            });

            new Swiper('.language__slider-rtl', {
                slidesPerView: 'auto',
                slidesPerGroup: 12,
                loop: true,
                speed: 80000,
                easing: 'linear',
                autoplay: {
                    delay: 0,
                },
                spaceBetween: 30,
            });
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/page_components/home/Language.vue